/* Bhavana Handlooms — theme-sections.js (loaded after theme-settings.js)
   Hero slider, deal-of-the-day countdown, desktop product image grid. */
(function(){
  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- product page: desktop shows images 2 per row ---------- */
  // each image gets its own frame so the hover zoom stays inside it
  var desktopGrid = window.matchMedia && matchMedia('(min-width: 990px)');
  function frameImages(){
    if(!desktopGrid || !desktopGrid.matches) return;
    document.querySelectorAll('[data-gallery] [data-media-scroller]').forEach(function(scroller){
      if(scroller.hasAttribute('data-framed')) return;
      scroller.setAttribute('data-framed', '');
      Array.prototype.slice.call(scroller.children).forEach(function(img){
        if(img.tagName !== 'IMG') return;
        var cell = document.createElement('div');
        cell.className = 'pdp-cell';
        scroller.insertBefore(cell, img);
        cell.appendChild(img);
        img.loading = 'eager';
      });
    });
  }
  frameImages();
  if(desktopGrid && desktopGrid.addEventListener) desktopGrid.addEventListener('change', frameImages);

  /* ---------- hero slider ---------- */
  function initSlider(root){
    if(!root || root._slider) return;
    var track = root.querySelector('[data-slider-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    if(!track || !slides.length) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slider-dot]'));
    var pauseBtn = root.querySelector('[data-slider-pause]');
    var fade = root.classList.contains('hs--fade');
    var autoplay = root.getAttribute('data-autoplay') === 'true' && slides.length > 1 && !reduceMotion;
    var index = 0;
    var timer = null;
    var userPaused = false;
    var hoverPaused = false;
    var editorPaused = false;
    var scrollTick = false;

    function mark(i){
      index = i;
      slides.forEach(function(s, n){
        var on = n === i;
        s.classList.toggle('is-active', on);
        if(on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        s.querySelectorAll('a,button').forEach(function(el){ if(on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
      });
      dots.forEach(function(d, n){
        d.classList.toggle('is-active', n === i);
        if(n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function go(i, smooth){
      var n = slides.length;
      i = ((i % n) + n) % n;
      if(fade){
        mark(i);
      } else {
        track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
        mark(i);
      }
      schedule();
    }
    function schedule(){
      clearTimeout(timer);
      if(!autoplay || userPaused || hoverPaused || editorPaused || document.hidden) return;
      var secs = parseFloat(slides[index].getAttribute('data-duration')) || 5;
      timer = setTimeout(function(){ go(index + 1, true); }, secs * 1000);
    }

    if(!fade){
      track.addEventListener('scroll', function(){
        if(scrollTick) return;
        scrollTick = true;
        requestAnimationFrame(function(){
          scrollTick = false;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if(i !== index && slides[i]){ mark(i); schedule(); }
        });
      }, { passive: true });
    } else {
      // swipe for the fade style
      var startX = null;
      track.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function(e){
        if(startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if(Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1), true);
      });
    }

    var prev = root.querySelector('[data-slider-prev]');
    var next = root.querySelector('[data-slider-next]');
    if(prev) prev.addEventListener('click', function(){ go(index - 1, true); });
    if(next) next.addEventListener('click', function(){ go(index + 1, true); });
    dots.forEach(function(d){ d.addEventListener('click', function(){ go(+d.getAttribute('data-slider-dot'), true); }); });
    if(pauseBtn){
      pauseBtn.addEventListener('click', function(){
        userPaused = !userPaused;
        root.classList.toggle('is-paused', userPaused);
        pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
        schedule();
      });
    }
    if(root.getAttribute('data-pause-hover') === 'true'){
      root.addEventListener('mouseenter', function(){ hoverPaused = true; schedule(); });
      root.addEventListener('mouseleave', function(){ hoverPaused = false; schedule(); });
    }
    root.addEventListener('focusin', function(){ hoverPaused = true; schedule(); });
    root.addEventListener('focusout', function(e){ if(!root.contains(e.relatedTarget)){ hoverPaused = false; schedule(); } });
    root.addEventListener('keydown', function(e){
      if(e.key === 'ArrowRight'){ go(index + 1, true); }
      if(e.key === 'ArrowLeft'){ go(index - 1, true); }
    });
    document.addEventListener('visibilitychange', schedule);
    window.addEventListener('resize', function(){ if(!fade) track.scrollTo({ left: slides[index].offsetLeft }); });

    root._slider = {
      go: go,
      editorPause: function(on){ editorPaused = on; schedule(); }
    };
    mark(0);
    schedule();
  }

  /* ---------- deal of the day countdown ---------- */
  function parseTz(tz){
    var m = /^([+-])(\d{1,2}):?(\d{2})?$/.exec((tz || '+05:30').trim());
    if(!m) return 330;
    var mins = (+m[2]) * 60 + (+(m[3] || 0));
    return m[1] === '-' ? -mins : mins;
  }
  function dealEnd(el){
    var offset = parseTz(el.getAttribute('data-tz'));
    var time = /^(\d{1,2}):(\d{2})$/.exec(el.getAttribute('data-end-time') || '23:59') || [0, 23, 59];
    var hh = +time[1], mm = +time[2];
    var nowUtc = Date.now();
    if(el.getAttribute('data-mode') === 'date'){
      var d = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(el.getAttribute('data-end-date') || '');
      if(!d) return null;
      return Date.UTC(+d[1], +d[2] - 1, +d[3], hh, mm) - offset * 60000;
    }
    // daily: today's end time in the store's time zone, or tomorrow's once it has passed
    var local = new Date(nowUtc + offset * 60000);
    var end = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate(), hh, mm) - offset * 60000;
    if(end <= nowUtc) end += 864e5;
    return end;
  }
  function pad(n){ return n < 10 ? '0' + n : String(n); }
  function initDeal(el){
    if(!el || el._deal) return;
    el._deal = true;
    var timerEl = el.querySelector('[data-deal-timer]');
    var endedEl = el.querySelector('[data-deal-ended]');
    var section = el.closest('.shopify-section') || el;
    var parts = {
      days: el.querySelector('[data-days]'), hours: el.querySelector('[data-hours]'),
      mins: el.querySelector('[data-mins]'), secs: el.querySelector('[data-secs]')
    };
    var daysWrap = el.querySelector('[data-days-wrap]');
    var preview = el.getAttribute('data-preview') === 'true';
    var end = dealEnd(el);
    if(end === null){ if(timerEl) timerEl.hidden = true; return; }
    if(timerEl) timerEl.hidden = false;
    var interval;
    function set(node, value){
      if(!node || node.textContent === value) return;
      node.textContent = value;
      var box = node.parentNode;
      if(!reduceMotion){ box.classList.remove('is-tick'); void box.offsetWidth; box.classList.add('is-tick'); }
    }
    function tick(){
      var left = end - Date.now();
      if(left <= 0){
        if(el.getAttribute('data-mode') === 'daily'){ end = dealEnd(el); return tick(); }
        clearInterval(interval);
        el.classList.add('is-ended');
        if(el.getAttribute('data-ended') === 'hide' && !preview){ section.hidden = true; return; }
        if(timerEl) timerEl.hidden = true;
        if(endedEl) endedEl.hidden = false;
        return;
      }
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      if(daysWrap) daysWrap.hidden = d === 0;
      set(parts.days, pad(d));
      set(parts.hours, pad(h));
      set(parts.mins, pad(m));
      set(parts.secs, pad(s));
      if(timerEl) timerEl.setAttribute('aria-label', (d ? d + ' days ' : '') + h + ' hours ' + m + ' minutes left');
    }
    tick();
    interval = setInterval(tick, 1000);
  }

  function initAll(scope){
    (scope || document).querySelectorAll('[data-slider]').forEach(initSlider);
    (scope || document).querySelectorAll('[data-deal]').forEach(initDeal);
  }
  initAll();

  /* ---------- share: wishlist "Share list" and product share button ---------- */
  // Phones use the native share menu. Elsewhere (or if it fails) a small panel offers WhatsApp and Copy link.
  var shareSheet = null;
  function buildShareSheet(){
    var el = document.createElement('div');
    el.className = 'share-sheet';
    el.hidden = true;
    el.innerHTML =
      '<div class="share-sheet__overlay" data-share-close></div>' +
      '<div class="share-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="ShareSheetTitle" tabindex="-1">' +
        '<div class="share-sheet__head"><p class="share-sheet__title" id="ShareSheetTitle">Share</p>' +
        '<button type="button" class="share-sheet__close" data-share-close aria-label="Close"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>' +
        '<div class="share-sheet__link"><label class="visually-hidden" for="ShareSheetLink">Link</label><input id="ShareSheetLink" type="text" readonly></div>' +
        '<div class="share-sheet__actions">' +
          '<a class="share-sheet__btn share-sheet__btn--wa" data-share-wa target="_blank" rel="noopener">WhatsApp</a>' +
          '<button type="button" class="share-sheet__btn" data-share-copy>Copy link</button>' +
          '<button type="button" class="share-sheet__btn" data-share-more hidden>More…</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    var input = el.querySelector('input');
    var copyBtn = el.querySelector('[data-share-copy]');
    el.addEventListener('click', function(e){
      if(e.target.closest('[data-share-close]')) return closeShareSheet();
      if(e.target.closest('[data-share-copy]')){
        var done = function(){ copyBtn.textContent = 'Copied!'; setTimeout(function(){ copyBtn.textContent = 'Copy link'; }, 1800); };
        var fallback = function(){
          input.focus(); input.select(); input.setSelectionRange(0, input.value.length);
          try { if(document.execCommand('copy')) return done(); } catch(err){}
          copyBtn.textContent = 'Press and hold the link to copy';
        };
        if(navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(input.value).then(done, fallback);
        else fallback();
      }
      if(e.target.closest('[data-share-more]') && navigator.share){
        navigator.share({ title: el._title, url: input.value }).catch(function(){});
      }
    });
    document.addEventListener('keydown', function(e){
      if(el.hidden) return;
      if(e.key === 'Escape'){ closeShareSheet(); return; }
      if(e.key !== 'Tab') return;
      // keep keyboard focus inside the panel
      var items = Array.prototype.slice.call(el.querySelectorAll('button:not([hidden]), a[href], input')).filter(function(x){ return x.offsetParent !== null; });
      if(!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if(e.shiftKey && (document.activeElement === first || !el.contains(document.activeElement))){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    });
    return el;
  }
  function openShareSheet(title, url, heading){
    shareSheet = shareSheet || buildShareSheet();
    shareSheet._title = title;
    shareSheet._return = document.activeElement;
    shareSheet.querySelector('.share-sheet__title').textContent = heading || 'Share';
    shareSheet.querySelector('input').value = url;
    shareSheet.querySelector('[data-share-wa]').href = 'https://wa.me/?text=' + encodeURIComponent(title + '\n' + url);
    shareSheet.querySelector('[data-share-more]').hidden = !navigator.share;
    shareSheet.hidden = false;
    document.documentElement.classList.add('scroll-lock');
    requestAnimationFrame(function(){ requestAnimationFrame(function(){
      shareSheet.classList.add('is-open');
      shareSheet.querySelector('[role="dialog"]').focus({ preventScroll: true });
    }); });
  }
  function closeShareSheet(){
    if(!shareSheet || shareSheet.hidden) return;
    shareSheet.classList.remove('is-open');
    if(!document.querySelector('[data-modal].is-open')) document.documentElement.classList.remove('scroll-lock');
    // a quick reopen keeps it visible
    setTimeout(function(){ if(!shareSheet.classList.contains('is-open')) shareSheet.hidden = true; }, reduceMotion ? 0 : 250);
    if(shareSheet._return && shareSheet._return.focus) shareSheet._return.focus({ preventScroll: true });
  }
  // capture phase, so this replaces the older share handlers in theme.js
  document.addEventListener('click', function(e){
    var trigger = e.target.closest && e.target.closest('[data-wishlist-share], [data-share]');
    if(!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var title, url, heading;
    if(trigger.hasAttribute('data-wishlist-share')){
      var list = [];
      try { list = JSON.parse(localStorage.getItem('bh:wishlist') || '[]'); } catch(err){}
      var link = new URL(document.body.getAttribute('data-wishlist-url') || '/search?view=wishlist', location.origin);
      link.searchParams.set('items', list.join(','));
      url = link.toString();
      title = 'My saved picks';
      heading = 'Share your saved list';
    } else {
      url = trigger.getAttribute('data-share-url') || location.href;
      title = trigger.getAttribute('data-share-title') || document.title;
      heading = 'Share this product';
    }
    var touch = window.matchMedia && matchMedia('(pointer: coarse)').matches;
    if(navigator.share && touch){
      navigator.share({ title: title, url: url }).catch(function(err){
        if(!err || err.name !== 'AbortError') openShareSheet(title, url, heading);
      });
    } else {
      openShareSheet(title, url, heading);
    }
  }, true);

  /* ---------- product page: Expo card countdown + entrance ---------- */
  document.querySelectorAll('[data-expo]').forEach(function(card){
    var istDay = function(str, endOfDay){
      var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec((str || '').trim());
      if(!m) return null;
      // store dates are India time (UTC+05:30)
      return Date.UTC(+m[1], +m[2] - 1, +m[3], endOfDay ? 23 : 0, endOfDay ? 59 : 0) - 330 * 60000;
    };
    var start = istDay(card.getAttribute('data-start'), false);
    var end = istDay(card.getAttribute('data-end'), true);
    var status = card.querySelector('[data-expo-status]');
    var now = Date.now();
    if(start !== null && end !== null){
      if(now > end){
        if(card.getAttribute('data-auto-hide') === 'true'){ card.hidden = true; return; }
      } else if(status){
        if(now >= start){
          var day = Math.floor((now - start) / 864e5) + 1;
          status.textContent = 'Happening now · Day ' + day;
          status.classList.add('is-live');
        } else {
          var days = Math.ceil((start - now) / 864e5);
          status.textContent = days <= 1 ? 'Starts tomorrow' : 'Starts in ' + days + ' days';
        }
        status.hidden = false;
      }
    }
    if(reduceMotion) return;
    card.classList.add('will-animate');
    var reveal = function(){
      if(card.classList.contains('is-in')) return;
      card.classList.add('is-in');
      window.removeEventListener('scroll', onScroll);
    };
    var onScroll = function(){
      if(card.getBoundingClientRect().top < window.innerHeight * 0.9) reveal();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        if(entries.some(function(entry){ return entry.isIntersecting; })){ reveal(); io.disconnect(); }
      }, { threshold: 0.1 });
      io.observe(card);
    }
    onScroll();
    setTimeout(reveal, 4000); // never leave the card hidden
  });

  /* ---------- Easify product options: heading "Custom stitching (+₹price)" ---------- */
  // the app renders the box after load and may re-render it, so keep the heading in sync
  (function(){
    var fix = function(root){
      var label = root.querySelector('.po-label-label');
      var help = root.querySelector('.po-field-helpText');
      if(!label) return;
      var price = help ? (help.textContent.match(/\(\s*\+\s*[^)]*\)/) || [])[0] : '';
      var text = 'Custom stitching' + (price ? ' ' + price.replace(/\s+/g, '') : '');
      var target = label.querySelector('div') || label;
      if(target.textContent !== text) target.textContent = text;
      root.classList.toggle('bh-price-in-label', !!price);
      // long HTML description stays collapsed until the shopper opens it
      root.querySelectorAll('.po-html-root').forEach(function(box){ box.classList.toggle('bh-open', detailsOpen); });
    };
    var detailsOpen = false;
    document.addEventListener('click', function(e){
      var box = e.target.closest && e.target.closest('.easify-product-options .po-html-root');
      // only the "Stitching details" bar toggles (not links or text inside the open panel)
      if(!box || e.target !== box) return;
      detailsOpen = !detailsOpen;
      box.classList.toggle('bh-open', detailsOpen);
    });
    var scan = function(){ document.querySelectorAll('.pdp-body .easify-product-options').forEach(fix); };
    var queued = false;
    var obs = new MutationObserver(function(){
      if(queued) return;
      queued = true;
      requestAnimationFrame(function(){ queued = false; scan(); });
    });
    var body = document.querySelector('.pdp-body');
    if(body){ obs.observe(body, { childList: true, subtree: true }); scan(); }
  })();

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); frameImages(); });
  document.addEventListener('shopify:block:select', function(e){
    var slider = e.target.closest('[data-slider]');
    if(!slider || !slider._slider) return;
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-slide]'));
    var i = slides.indexOf(e.target);
    if(i > -1){ slider._slider.editorPause(true); slider._slider.go(i, false); }
  });
  document.addEventListener('shopify:block:deselect', function(e){
    var slider = e.target.closest('[data-slider]');
    if(slider && slider._slider) slider._slider.editorPause(false);
  });
})();
